import React, { useState } from "react";
import { useDispatch } from "react-redux";

import withModal from "../withModal";
import MaterialModal from "../MaterialModal";
import ImportBulkActionMain from "./ImportBulkActionMain";
import { requestAddBulkFields, setProperty } from "../../../actions/adminDesignerActions";
import { hideModal } from "../../../actions/actionCreators";
import { IImportBulkField } from "../../../types/stores/adminDesigner";
import { AdminDesignerProperties } from "../../../reducers/adminDesigner";

interface IImportBulkActionModal {
    isOpen: boolean;
}

const ImportBulkActionModal: React.FC<IImportBulkActionModal> = ({ isOpen }: IImportBulkActionModal) => {
    const dispatch = useDispatch();

    const [importedFields, setImportedFields] = useState<Array<IImportBulkField>>([]);
    const [showPrimaryButton, setShowPrimaryButton] = useState(false);

    const hide = () => dispatch(hideModal("COMPANY_IMPORT_BULKSETTING"));
    const saveImport = () => {
        dispatch(setProperty(AdminDesignerProperties.importedBulkFields, importedFields));
        dispatch(requestAddBulkFields(importedFields));
        setImportedFields([]);
        hide();
    };
    const prepareHide = () => {
        setImportedFields([]);
        handleDelete(true);
        hide();
    };

    const handleDelete = (data: boolean) => {
        setShowPrimaryButton(!data);
    };

    return (
        <MaterialModal
            id="variable-admin-modal"
            isOpen={isOpen}
            onClose={prepareHide}
            onPrimaryButtonRequest={saveImport}
            title="Import Field Visibility Bulk Management"
            showPrimaryButton={showPrimaryButton}
            primaryButtonText="Save"
            cancelButtonText="Close"
        >
            <div>
                <ImportBulkActionMain
                    importedBulkFields={importedFields}
                    updateFields={setImportedFields}
                    onChangeImportAction={handleDelete}
                />
            </div>
        </MaterialModal>
    );
};

export default withModal(ImportBulkActionModal, "COMPANY_IMPORT_BULKSETTING");
